<div class="aspect-square bg-surface rounded-lg overflow-hidden flex items-center justify-center">
    <img *ngIf="selectedAsset" [src]="selectedAsset | assetPreview:540" alt=""
         (click)="openImage(selectedAsset?.id)"
         (load)="onLoad()"
         class="w-full h-full object-contain cursor-zoom-in"
    />
    <div *ngIf="!selectedAsset || !featuredAssetLoaded"
         class="w-full h-full bg-gray-200 animate-pulse"></div>
</div>

<div class="flex flex-wrap space-x-2 mt-2" *ngIf="1 < assets?.length">
    <div *ngFor="let asset of assets"
         (click)="selectImage(asset.id)">
        <img [src]="asset | assetPreview:'thumb'" class="rounded-lg select-none h-24 w-full object-cover cursor-pointer">
    </div>
</div>
